const MOCK_MODE_KEY = "DEBUG_USE_MOCKS";
const MOCK_API_KEY = "DEBUG_MOCK_API_KEY";

const readMockApiEnabled = (): boolean => localStorage.getItem(MOCK_MODE_KEY) === "true";

const writeMockApiEnabled = (isEnabled: boolean): void => {
  localStorage.setItem(MOCK_MODE_KEY, isEnabled ? "true" : "false");
};

const readMockApiKey = (): string => localStorage.getItem(MOCK_API_KEY) ?? "";

const writeMockApiKey = (apiKey: string): void => {
  localStorage.setItem(MOCK_API_KEY, apiKey);
};

export { readMockApiEnabled, readMockApiKey, writeMockApiEnabled, writeMockApiKey };
